export const IMPLANTS_SEPARATOR = "\n:משתלים\n";

export function getGeneralResources(resources) {
  if (!resources) return "";
  return resources.split(IMPLANTS_SEPARATOR)[0] || "";
}

export function getImplantsResources(resources) {
  if (!resources) return "";
  return resources.split(IMPLANTS_SEPARATOR)[1] || "";
}

export function combineResources(general, implants) {
  if (!general && !implants) return "";
  if (!implants) return general;
  if (!general) return `${IMPLANTS_SEPARATOR}${implants}`;
  return `${general}${IMPLANTS_SEPARATOR}${implants}`;
}
